import * as constants from '../constants';

const initialState = {
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCultures.success: {
            return action.payload;
        }

        case constants.getCultures.try:
        case constants.getCultures.error: {
            return initialState;
        }

        default:
            return state;
    }
}
